import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "plan-definition-container app-page app-page--fill" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "left-panel" }
const _hoisted_4 = { class: "plan-list-wrapper" }
const _hoisted_5 = { class: "right-panel" }
const _hoisted_6 = {
  class: "plan-detail-container",
  "element-loading-text": "加载中..."
}
const _hoisted_7 = {
  key: 0,
  class: "edit-area"
}
const _hoisted_8 = { class: "edit-mode-control" }
const _hoisted_9 = { class: "left-actions" }
const _hoisted_10 = {
  key: 0,
  class: "right-actions"
}
const _hoisted_11 = { class: "default-plan-control" }
const _hoisted_12 = { class: "selected-plan-name" }
const _hoisted_13 = {
  key: 1,
  class: "selected-plan-empty"
}
const _hoisted_14 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_15 = { class: "record-list-container" }
const _hoisted_16 = { class: "dialog-pagination" }
const _hoisted_17 = { class: "dialog-footer" }

import { computed, nextTick, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Close, DocumentChecked, Edit, Plus, Refresh, RefreshLeft } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import PageHeader from '@/components/PageHeader.vue';
import DynamicTable from '@/components/DynamicTable.vue';
import { ParameterSettings } from '@/network/index';
import { getMenuChildPathByComponent } from '@/utils/menuRoute';

interface HouseCheckPlanData {
  id: string;
  projectName: string;
  projectCode: string;
  defaultPlanId: string;
  defaultPlanName: string;
  clientName: string;
  clientPhone: string;
  ownerName: string;
  ownerPhone: string;
  userName: string;
  managerName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const planList = ref<any[]>([]);
const planTableModel = ref<Record<string, string> | undefined>(undefined);
const planHiddenColumns = ['状态', 'status', 'Status'];
const hiddenPlanListFields = new Set(planHiddenColumns.map(field => field.toLowerCase()));
const planTableLabels: Record<string, string> = {
  ID: 'ID',
  Id: 'ID',
  id: 'ID',
  项目名称: '项目名称',
  项目编码: '项目编码',
  委托人: '委托人',
  委托人联系电话: '委托人联系电话',
  所有权人: '所有权人',
  所有权人联系电话: '所有权人联系电话',
  使用人: '使用人',
  管理人: '管理人'
};
const planTableColumnOrder = ['项目名称', '项目编码', '委托人', '委托人联系电话', '所有权人', '所有权人联系电话', '使用人', '管理人'];

const listLoading = ref<boolean>(false);
const detailLoading = ref<boolean>(false);
const saveLoading = ref<boolean>(false);
const isEditMode = ref<boolean>(false);
const activePlanIndex = ref<number>(-1);
const filterParams = ref<any[]>([]);
const currentPlan = ref<HouseCheckPlanData | null>(null);
const inspectionRecordList = ref<any[]>([]);
const planFormRef = ref<any>(null);
const defaultPlanDialogVisible = ref<boolean>(false);
const defaultPlanListLoading = ref<boolean>(false);
const defaultPlanList = ref<any[]>([]);
const selectedDefaultPlanId = ref<string>('');
const selectedDefaultPlanRow = ref<any | null>(null);

const planPagination = ref({
  show: true,
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100],
  layout: 'total, prev, pager, next',
  small: true
});

const defaultPlanPagination = ref({
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100]
});

const validateDefaultPlanId = (_rule: any, value: string, callback: (error?: Error) => void) => {
  if (!value || value === '0') {
    callback(new Error('请选择默认体检方案'));
    return;
  }
  callback();
};

const planFormRules = {
  projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
  projectCode: [{ required: true, message: '请输入项目编码', trigger: 'blur' }],
  clientName: [{ required: true, message: '请输入委托人', trigger: 'blur' }],
  clientPhone: [{ required: true, message: '请输入委托人联系电话', trigger: 'blur' }],
  ownerName: [{ required: true, message: '请输入所有权人', trigger: 'blur' }],
  ownerPhone: [{ required: true, message: '请输入所有权人联系电话', trigger: 'blur' }],
  userName: [{ required: true, message: '请输入使用人', trigger: 'blur' }],
  managerName: [{ required: true, message: '请输入管理人', trigger: 'blur' }],
  defaultPlanId: [{ validator: validateDefaultPlanId, trigger: 'change' }]
};

const activePlanRowKey = computed(() => {
  if (activePlanIndex.value < 0 || activePlanIndex.value >= planList.value.length) return null;
  const item = planList.value[activePlanIndex.value];
  return item?.ID ?? item?.Id ?? item?.id ?? null;
});

const getRowId = (row: any) => row?.ID ?? row?.Id ?? row?.id ?? '';

const getDefaultPlanName = (row: any) => row?.名称 ?? row?.name ?? row?.报告模板名称 ?? '未命名体检方案';

const normalizeId = (value: any): string => {
  const text = String(value ?? '');
  return text === '0' ? '' : text;
};

const formatDateText = (value: any): string => {
  if (!value) return '-';
  return String(value).replace('T', ' ');
};

const createEmptyPlan = (): HouseCheckPlanData => ({
  id: '',
  projectName: '',
  projectCode: '',
  defaultPlanId: '',
  defaultPlanName: '',
  clientName: '',
  clientPhone: '',
  ownerName: '',
  ownerPhone: '',
  userName: '',
  managerName: ''
});

const isHiddenPlanField = (fieldName: any) => hiddenPlanListFields.has(String(fieldName ?? '').toLowerCase());

const transformBackendToPlanData = (data: any): HouseCheckPlanData => ({
  id: String(data?.ID ?? data?.Id ?? data?.id ?? ''),
  projectName: data?.项目名称 ?? data?.projectName ?? '',
  projectCode: data?.项目编码 ?? data?.projectCode ?? '',
  defaultPlanId: normalizeId(data?.默认体检方案id ?? data?.默认体检方案Id ?? data?.defaultPlanId),
  defaultPlanName: '',
  clientName: data?.委托人 ?? data?.clientName ?? '',
  clientPhone: data?.委托人联系电话 ?? data?.clientPhone ?? '',
  ownerName: data?.所有权人 ?? data?.ownerName ?? '',
  ownerPhone: data?.所有权人联系电话 ?? data?.ownerPhone ?? '',
  userName: data?.使用人 ?? data?.userName ?? '',
  managerName: data?.管理人 ?? data?.managerName ?? ''
});

const transformPlanDataToBackend = (data: HouseCheckPlanData) => ({
  项目名称: data.projectName || '',
  项目编码: data.projectCode || '',
  委托人: data.clientName,
  委托人联系电话: data.clientPhone,
  所有权人: data.ownerName,
  所有权人联系电话: data.ownerPhone,
  使用人: data.userName,
  管理人: data.managerName,
  默认体检方案id: data.defaultPlanId || '0',
  Id: data.id || '0'
});

const findPlanIndex = (row: any): number => {
  const rowId = String(getRowId(row));
  return planList.value.findIndex((item: any) => {
    const itemId = String(getRowId(item));
    return rowId && itemId ? itemId === rowId : item === row;
  });
};

const findPlanItem = (targetId?: number | string): any => {
  if (targetId === undefined || targetId === null || targetId === '') return null;
  const targetText = String(targetId);
  return planList.value.find((item: any) => String(getRowId(item)) === targetText);
};

const selectedDefaultPlanName = computed(() => {
  if (!currentPlan.value?.defaultPlanId) return '未选择';
  return currentPlan.value.defaultPlanName || '已选择默认体检方案';
});

const resolveDefaultPlanNameById = async (id: string) => {
  if (!id || !currentPlan.value) return;
  try {
    const res = await ParameterSettings.houseCheckById({ id });
    if (res && res.status === 200 && res.success && res.response && currentPlan.value?.defaultPlanId === id) {
      currentPlan.value.defaultPlanName = res.response.名称 || res.response.name || currentPlan.value.defaultPlanName;
    }
  } catch (error) {
    console.error('加载默认体检方案名称失败:', error);
  }
};

const loadDefaultPlanList = async () => {
  try {
    defaultPlanListLoading.value = true;
    const paginationData = {
      page: defaultPlanPagination.value.page,
      intPageSize: defaultPlanPagination.value.pageSize
    };
    const res = await ParameterSettings.houseCheckListIndex(paginationData, []);
    if (res && res.status === 200 && res.success && res.response) {
      const responseData = Array.isArray(res.response) ? res.response : (res.response.data || []);
      defaultPlanList.value = Array.isArray(responseData) ? responseData : [];
      defaultPlanPagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;

      const currentSelected = defaultPlanList.value.find((item: any) => String(getRowId(item)) === selectedDefaultPlanId.value);
      if (currentSelected) {
        selectedDefaultPlanRow.value = currentSelected;
      }
    } else {
      defaultPlanList.value = [];
      defaultPlanPagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载默认体检方案列表失败:', error);
    defaultPlanList.value = [];
    defaultPlanPagination.value.total = 0;
    ElMessage.error('加载默认体检方案列表失败');
  } finally {
    defaultPlanListLoading.value = false;
  }
};

const openDefaultPlanDialog = async () => {
  if (!isEditMode.value) return;
  selectedDefaultPlanId.value = currentPlan.value?.defaultPlanId || '';
  selectedDefaultPlanRow.value = null;
  defaultPlanPagination.value.page = 1;
  defaultPlanDialogVisible.value = true;
  await loadDefaultPlanList();
};

const selectDefaultPlanRow = (row: any) => {
  const rowId = getRowId(row);
  if (!rowId) return;
  selectedDefaultPlanId.value = String(rowId);
  selectedDefaultPlanRow.value = row;
};

const confirmDefaultPlanSelection = async () => {
  if (!selectedDefaultPlanId.value) {
    ElMessage.warning('请选择默认体检方案');
    return;
  }
  if (!currentPlan.value) return;
  currentPlan.value.defaultPlanId = selectedDefaultPlanId.value;
  currentPlan.value.defaultPlanName = selectedDefaultPlanRow.value ? getDefaultPlanName(selectedDefaultPlanRow.value) : '';
  defaultPlanDialogVisible.value = false;
  await nextTick();
  planFormRef.value?.validateField?.('defaultPlanId');
};

const clearDefaultPlan = async () => {
  if (!currentPlan.value) return;
  currentPlan.value.defaultPlanId = '';
  currentPlan.value.defaultPlanName = '';
  await nextTick();
  planFormRef.value?.validateField?.('defaultPlanId');
};

const handleDefaultPlanPageChange = (page: number) => {
  defaultPlanPagination.value.page = page;
  loadDefaultPlanList();
};

const handleDefaultPlanPageSizeChange = (pageSize: number) => {
  defaultPlanPagination.value.pageSize = pageSize;
  defaultPlanPagination.value.page = 1;
  loadDefaultPlanList();
};

const loadPlanList = async () => {
  try {
    listLoading.value = true;
    const paginationData = {
      page: planPagination.value.page,
      intPageSize: planPagination.value.pageSize
    };
    const res = await ParameterSettings.houseCheckPlanListIndex(paginationData, filterParams.value);

    if (res && res.status === 200 && res.success && res.response) {
      const responseList = Array.isArray(res.response.data) ? res.response.data : [];
      planList.value = responseList;
      planPagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;
      planTableModel.value = res.response.model && typeof res.response.model === 'object'
        ? res.response.model
        : undefined;
    } else {
      planList.value = [];
      planTableModel.value = undefined;
      planPagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载体检方案定义列表失败:', error);
    planList.value = [];
    ElMessage.error('加载体检方案定义列表失败');
  } finally {
    listLoading.value = false;
  }
};

const handleFilter = (filters: any[]) => {
  filterParams.value = filters.filter((item: any) => !isHiddenPlanField(item?.FieldName ?? item?.fieldName));
  planPagination.value.page = 1;
  loadPlanList();
};

const handlePlanPageChange = (page: number) => {
  planPagination.value.page = page;
  loadPlanList();
};

const handlePlanPageSizeChange = (pageSize: number) => {
  planPagination.value.pageSize = pageSize;
  planPagination.value.page = 1;
  loadPlanList();
};

const handlePlanSelect = async (row: any) => {
  const itemId = getRowId(row);
  if (!itemId) return;

  const index = findPlanIndex(row);
  activePlanIndex.value = index;

  try {
    detailLoading.value = true;
    const res = await ParameterSettings.houseCheckPlanById({ id: itemId });
    if (res && res.status === 200 && res.success && res.response) {
      currentPlan.value = transformBackendToPlanData(res.response);
      inspectionRecordList.value = Array.isArray(res.response.房屋建筑定期体检项目原始数据主表集合)
        ? res.response.房屋建筑定期体检项目原始数据主表集合
        : [];
      isEditMode.value = false;
      if (currentPlan.value.defaultPlanId) {
        resolveDefaultPlanNameById(currentPlan.value.defaultPlanId);
      }
      await nextTick();
      planFormRef.value?.clearValidate?.();
    } else {
      currentPlan.value = null;
      inspectionRecordList.value = [];
      isEditMode.value = false;
      ElMessage.error('数据加载失败');
    }
  } catch (error) {
    console.error('加载体检方案定义详情失败:', error);
    currentPlan.value = null;
    inspectionRecordList.value = [];
    isEditMode.value = false;
    ElMessage.error('数据加载失败');
  } finally {
    detailLoading.value = false;
  }
};

const handlePlanEdit = (row: any) => {
  handlePlanSelect(row);
};

const openRecordDetail = (row: any) => {
  const recordId = row?.Id ?? row?.ID ?? row?.id;
  if (!recordId) {
    ElMessage.warning('未获取到体检记录ID');
    return;
  }
  router.push({
    path: getMenuChildPathByComponent(
      '/HomeInspection/HouseCheckPlanDefinition/index.vue',
      '体检记录详情',
      '/房屋建筑定期体检/体检项目定义/体检记录详情'
    ),
    query: { id: String(recordId) }
  });
};

const addNewPlan = async () => {
  currentPlan.value = createEmptyPlan();
  inspectionRecordList.value = [];
  activePlanIndex.value = -1;
  isEditMode.value = true;
  await nextTick();
  planFormRef.value?.clearValidate?.();
};

const enterEditMode = () => {
  if (!currentPlan.value) return;
  (currentPlan.value as any)._backup = JSON.parse(JSON.stringify(currentPlan.value));
  isEditMode.value = true;
};

const exitEditMode = () => {
  if (!currentPlan.value) return;
  const backup = (currentPlan.value as any)._backup;
  if (backup) {
    currentPlan.value = backup;
    delete (currentPlan.value as any)._backup;
  } else if (!currentPlan.value.id) {
    currentPlan.value = null;
    inspectionRecordList.value = [];
  }
  isEditMode.value = false;
};

const resetCurrentPlan = async () => {
  if (!currentPlan.value) return;
  if (currentPlan.value.id) {
    const currentItem = findPlanItem(currentPlan.value.id);
    if (currentItem) {
      await handlePlanSelect(currentItem);
      isEditMode.value = true;
    }
  } else {
    currentPlan.value = createEmptyPlan();
    inspectionRecordList.value = [];
    await nextTick();
    planFormRef.value?.clearValidate?.();
  }
};

const savePlanData = async () => {
  if (!currentPlan.value || !planFormRef.value) return;

  await planFormRef.value.validate(async (valid: boolean) => {
    if (!valid || !currentPlan.value) {
      ElMessage.warning('请填写必填项后再保存');
      return;
    }

    const isNew = !currentPlan.value.id;
    const submitData = transformPlanDataToBackend(currentPlan.value);

    try {
      saveLoading.value = true;
      const res = await ParameterSettings.houseCheckPlanSave(submitData);
      if (res && res.status === 200 && res.success) {
        ElMessage.success(isNew ? '新增成功' : '更新成功');
        isEditMode.value = false;
        const savedId = res.response?.ID ?? res.response?.Id ?? res.response?.id ?? submitData.Id;
        if (isNew) {
          planPagination.value.page = 1;
        }
        await loadPlanList();
        const foundItem = findPlanItem(savedId);
        if (foundItem) {
          await handlePlanSelect(foundItem);
        } else {
          currentPlan.value = null;
          inspectionRecordList.value = [];
          activePlanIndex.value = -1;
        }
      } else {
        ElMessage.error(isNew ? '新增失败' : '更新失败');
      }
    } catch (error) {
      console.error('保存体检方案定义失败:', error);
      ElMessage.error(isNew ? '新增失败' : '更新失败');
    } finally {
      saveLoading.value = false;
    }
  });
};

const handlePlanDelete = (row: any) => {
  const index = findPlanIndex(row);
  const itemId = getRowId(row);
  if (index < 0 || !itemId) return;

  ElMessageBox.confirm('确定要删除这个体检方案定义吗？删除后无法恢复', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res = await ParameterSettings.houseCheckPlanDelete({ id: itemId });
      if (res && res.status === 200 && res.success) {
        const activeId = currentPlan.value?.id;
        if (activeId && String(activeId) === String(itemId)) {
          currentPlan.value = null;
          inspectionRecordList.value = [];
          activePlanIndex.value = -1;
          isEditMode.value = false;
        }
        if (planList.value.length === 1 && planPagination.value.page > 1) {
          planPagination.value.page--;
        }
        await loadPlanList();
        ElMessage.success('删除成功');
      } else {
        ElMessage.error('删除失败');
      }
    } catch (error) {
      console.error('删除体检方案定义失败:', error);
      ElMessage.error('删除失败');
    }
  }).catch(() => { /* cancelled */ });
};

onMounted(() => {
  loadPlanList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "list-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("体检方案列表")
              ])),
              actions: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: _unref(Plus),
                  onClick: addNewPlan
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("新增")
                  ])),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  circle: "",
                  size: "small",
                  class: "app-refresh-btn",
                  icon: _unref(Refresh),
                  loading: listLoading.value,
                  title: "刷新",
                  onClick: loadPlanList
                }, null, 8, ["icon", "loading"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(DynamicTable, {
                data: planList.value,
                model: planTableModel.value,
                "column-labels": planTableLabels,
                "column-order": planTableColumnOrder,
                "hidden-columns": planHiddenColumns,
                loading: listLoading.value,
                "show-column-selector": false,
                "show-export": false,
                "show-edit-button": true,
                "show-delete-button": true,
                pagination: planPagination.value,
                "active-row-key": activePlanRowKey.value,
                onEdit: handlePlanEdit,
                onDelete: handlePlanDelete,
                onFilter: handleFilter,
                onPageChange: handlePlanPageChange,
                onPageSizeChange: handlePlanPageSizeChange
              }, null, 8, ["data", "model", "loading", "pagination", "active-row-key"])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "plan-form-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("体检方案详情")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              (currentPlan.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (!isEditMode.value)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              icon: _unref(Edit),
                              onClick: enterEditMode
                            }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode(" 编辑 ")
                              ])),
                              _: 1
                            }, 8, ["icon"]))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              icon: _unref(Close),
                              onClick: exitEditMode
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode(" 取消编辑 ")
                              ])),
                              _: 1
                            }, 8, ["icon"]))
                      ]),
                      (isEditMode.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              icon: _unref(DocumentChecked),
                              loading: saveLoading.value,
                              onClick: savePlanData
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" 保存数据 ")
                              ])),
                              _: 1
                            }, 8, ["icon", "loading"]),
                            _createVNode(_component_el_button, {
                              icon: _unref(RefreshLeft),
                              disabled: saveLoading.value,
                              onClick: resetCurrentPlan
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" 重置 ")
                              ])),
                              _: 1
                            }, 8, ["icon", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_form, {
                      ref_key: "planFormRef",
                      ref: planFormRef,
                      model: currentPlan.value,
                      rules: planFormRules,
                      "label-width": "150px",
                      class: "form-content"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "项目名称",
                                  prop: "projectName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.projectName,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPlan.value.projectName) = $event)),
                                      placeholder: "请输入项目名称",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "项目编码",
                                  prop: "projectCode"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.projectCode,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPlan.value.projectCode) = $event)),
                                      placeholder: "请输入项目编码",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "委托人",
                                  prop: "clientName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.clientName,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPlan.value.clientName) = $event)),
                                      placeholder: "请输入委托人",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "委托人联系电话",
                                  prop: "clientPhone"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.clientPhone,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPlan.value.clientPhone) = $event)),
                                      placeholder: "请输入委托人联系电话",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "所有权人",
                                  prop: "ownerName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.ownerName,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentPlan.value.ownerName) = $event)),
                                      placeholder: "请输入所有权人",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "所有权人联系电话",
                                  prop: "ownerPhone"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.ownerPhone,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentPlan.value.ownerPhone) = $event)),
                                      placeholder: "请输入所有权人联系电话",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "使用人",
                                  prop: "userName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.userName,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentPlan.value.userName) = $event)),
                                      placeholder: "请输入使用人",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 12,
                              lg: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "管理人",
                                  prop: "managerName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentPlan.value.managerName,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentPlan.value.managerName) = $event)),
                                      placeholder: "请输入管理人",
                                      readonly: !isEditMode.value
                                    }, null, 8, ["modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, { gutter: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              xs: 24,
                              sm: 24,
                              md: 24,
                              lg: 24
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "默认体检方案",
                                  prop: "defaultPlanId"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        plain: "",
                                        class: "choose-plan-btn",
                                        disabled: !isEditMode.value,
                                        onClick: openDefaultPlanDialog
                                      }, {
                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                          _createTextVNode(" 选择默认体检方案 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      (currentPlan.value.defaultPlanId)
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 0,
                                            type: "success",
                                            effect: "light",
                                            class: "selected-plan-tag"
                                          }, {
                                            default: _withCtx(() => [
                                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "selected-plan-prefix" }, "已选", -1)),
                                              _createElementVNode("span", _hoisted_12, _toDisplayString(selectedDefaultPlanName.value), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "未选择体检方案")),
                                      (isEditMode.value && currentPlan.value.defaultPlanId)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 2,
                                            type: "danger",
                                            link: "",
                                            onClick: clearDefaultPlan
                                          }, {
                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                              _createTextVNode(" 清空 ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_el_empty, { description: "请先创建或选择一个体检方案定义" })
                  ]))
            ])), [
              [_directive_loading, detailLoading.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "hover",
          class: "plan-record-card"
        }, {
          header: _withCtx(() => [
            _createVNode(PageHeader, { size: "card" }, {
              title: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("体检记录列表")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (inspectionRecordList.value.length)
                ? (_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    data: inspectionRecordList.value,
                    border: "",
                    stripe: "",
                    height: "100%",
                    size: "small",
                    class: "record-table"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "评估类型",
                        label: "评估类型",
                        "min-width": "120",
                        "show-overflow-tooltip": ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.评估类型 || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "体检人员",
                        label: "体检人员",
                        "min-width": "120",
                        "show-overflow-tooltip": ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.体检人员 || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "提交时间",
                        label: "提交时间",
                        "min-width": "170",
                        "show-overflow-tooltip": ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(formatDateText(row.提交时间)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "数据唯一ID",
                        label: "数据唯一ID",
                        "min-width": "150",
                        "show-overflow-tooltip": ""
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.数据唯一ID || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        width: "100",
                        fixed: "right",
                        align: "center"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            link: "",
                            onClick: ($event: any) => (openRecordDetail(row))
                          }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode(" 详情 ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无体检记录"
                  }))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: defaultPlanDialogVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((defaultPlanDialogVisible).value = $event)),
      title: "选择默认体检方案",
      width: "820px",
      top: "6vh",
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (defaultPlanDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmDefaultPlanSelection
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: selectedDefaultPlanId.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedDefaultPlanId).value = $event)),
          class: "default-plan-radio-group"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: defaultPlanList.value,
              border: "",
              stripe: "",
              "highlight-current-row": "",
              height: "430",
              "row-key": getRowId,
              onRowClick: selectDefaultPlanRow
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "选择",
                  width: "70",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_radio, {
                      label: String(getRowId(row)),
                      onChange: ($event: any) => (selectDefaultPlanRow(row))
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("   ")
                      ])),
                      _: 2
                    }, 1032, ["label", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "名称",
                  label: "体检方案名称",
                  "min-width": "220"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(getDefaultPlanName(row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "最后修改人",
                  label: "最后修改人",
                  width: "130"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.最后修改人 || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "版本",
                  label: "版本",
                  width: "110"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.版本 || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "实施日期",
                  label: "实施日期",
                  width: "180"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(formatDateText(row.实施日期)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, defaultPlanListLoading.value]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_pagination, {
            "current-page": defaultPlanPagination.value.page,
            "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((defaultPlanPagination.value.page) = $event)),
            "page-size": defaultPlanPagination.value.pageSize,
            "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((defaultPlanPagination.value.pageSize) = $event)),
            "page-sizes": defaultPlanPagination.value.pageSizes,
            total: defaultPlanPagination.value.total,
            layout: "total, sizes, prev, pager, next, jumper",
            small: "",
            onSizeChange: handleDefaultPlanPageSizeChange,
            onCurrentChange: handleDefaultPlanPageChange
          }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})